<template>
    <section>
        <b-img :src="info.src" fluid :alt="info.alt"></b-img>
    </section>
</template>

<script>
export default {
    props: ['info'],
}
</script>

<style>

</style>